import { render, staticRenderFns } from "./ConfirmationItemSummary.vue?vue&type=template&id=02e401c3&scoped=true&"
import script from "./ConfirmationItemSummary.vue?vue&type=script&lang=js&"
export * from "./ConfirmationItemSummary.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationItemSummary.vue?vue&type=style&index=0&id=02e401c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e401c3",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BTable} from 'bootstrap-vue'
    installComponents(component, {BTable})
    

export default component.exports